import React from "react";
import { Table } from "../Table";
import { useFormattedTransactions } from "@/hooks/data/useFormattedTransactions";
import useProtocol from "@/hooks/api/useProtocol";

import { columns } from "./constants";

interface TxListProps {
  slug: string;
}

export function TxListContainer({ slug }: TxListProps) {
  const { data: protocol } = useProtocol(slug);
  const { isLoading, formattedTransactions, setPage } = useFormattedTransactions({ protocolId: protocol?.id });

  return (
    <Table
      className="grid h-full w-full"
      loading={isLoading}
      rows={formattedTransactions}
      columns={columns}
      onScrollToBottom={() => {
        void setPage(page => page + 1);
      }}
    />
  );
}
